import { Link } from 'react-router-dom';

export default function Hero() {
  return (
    <section 
      className="relative bg-cover bg-center min-h-[90vh] flex items-center"
      style={{
        backgroundImage: `linear-gradient(to right, rgba(255, 255, 255, 0.95) 0%, rgba(255, 255, 255, 0.85) 50%, rgba(255, 255, 255, 0.3) 100%), url('https://public.readdy.ai/ai/img_res/79029b07-e619-4698-98f5-f32a3aed7ab0.jpg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-6 py-20 lg:px-8 w-full">
        <div className="max-w-2xl">
          <h1 className="text-5xl font-bold text-gray-900 mb-6 leading-tight">
            Transforma tu Pasión por los Perros en una <span className="text-primary-500">Profesión Certificada</span>
          </h1>
          <p className="text-xl text-gray-700 mb-4 leading-relaxed">
            Formación adaptada al INCUAL. Obtén tu certificado de profesionalidad oficial según RD 545/2023 y RD 917/2024.
          </p>
          <p className="text-lg text-gray-600 mb-8 font-semibold">
            Aprende técnicas profesionales de adiestramiento, modificación de conductas y cuidados especializados con metodología paso a paso.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Link
              to="/cursos"
              className="inline-flex items-center justify-center rounded-full bg-accent-500 px-8 py-4 text-base font-semibold text-white shadow-lg hover:bg-accent-600 transition-all hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              Explorar Cursos
              <i className="ri-arrow-right-line ml-2 text-xl"></i>
            </Link>
            <Link
              to="/nosotros"
              className="inline-flex items-center justify-center rounded-full bg-white border-2 border-gray-300 px-8 py-4 text-base font-semibold text-gray-900 hover:border-primary-500 hover:text-primary-500 transition-all whitespace-nowrap cursor-pointer"
            >
              Conocer Más
            </Link>
          </div>
          <div className="mt-12 flex items-center gap-8">
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center">
                <i className="ri-shield-check-fill text-secondary-600 text-2xl"></i>
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">100%</p>
                <p className="text-sm text-gray-600">Adaptado al INCUAL</p>
              </div>
            </div>
            <div className="flex items-center gap-3">
              <div className="w-12 h-12 bg-secondary-100 rounded-full flex items-center justify-center">
                <i className="ri-group-fill text-secondary-600 text-2xl"></i>
              </div>
              <div>
                <p className="text-2xl font-bold text-gray-900">500+</p>
                <p className="text-sm text-gray-600">Alumnos Formados</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
